import React from 'react';
import { extendedHtmlTags, visualizationHtmlTags } from "./utils";

const isValidTagName = (tagName, sanitized) =>
!sanitized ? extendedHtmlTags.includes(tagName) : visualizationHtmlTags.includes(tagName);

const ValidatedElement = (
type,
props,
children,
sanitized = true) =>
{
  if (typeof type === 'string' && !isValidTagName(type, sanitized)) {
    return /*#__PURE__*/React.createElement('div', { className: 'error' }, `Invalid tag: ${type}`);
  }

  const validatedChildren = children.map((child) => {
    if (Array.isArray(child)) {
      return child.map((c) => {
        const childProps = c.props;
        return /*#__PURE__*/React.isValidElement(c) ?
        ValidatedElement(
          c.type,
          childProps,
          React.Children.toArray(childProps.children),
          sanitized
        ) :
        c;
      });
    }
    if (/*#__PURE__*/React.isValidElement(child)) {
      return ValidatedElement(
        child.type,
        child.props,
        React.Children.toArray(child.props.children),
        sanitized
      );
    }
    return child;
  });

  return /*#__PURE__*/React.createElement(type, props, ...validatedChildren);
};

export { ValidatedElement };